import React from 'react';
import { motion } from 'framer-motion';

const ToolCategory = ({ category, currentTool, onSelectTool }) => {
  return (
    <div className="p-4 border-b border-gray-100 last:border-b-0">
      <h4 className="text-sm font-semibold text-gray-600 mb-3">
        {category.title}
      </h4>
      
      <div className="space-y-2">
        {category.tools.map((tool, index) => (
          <motion.div
            key={tool.id}
            className={`
              p-3 rounded-lg cursor-pointer border-l-3 transition-all duration-200
              ${currentTool === tool.id 
                ? 'bg-purple-50 border-l-purple-500 shadow-sm' 
                : 'hover:bg-gray-50 border-l-transparent'
              }
            `}
            onClick={() => onSelectTool(tool.id)}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg ${tool.color} flex items-center justify-center text-lg`}>
                {tool.icon}
              </div>
              <div className="flex-1">
                <h5 className="font-medium text-gray-800 text-sm">
                  {tool.title}
                </h5>
                <p className="text-xs text-gray-500 mt-1">
                  {tool.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ToolCategory;